import { onCleanup, onMount } from "solid-js";

export function useViewportReflowFix(ref: HTMLElement) {
  let timer: number;
  let lastHeight: number;

  onMount(() => {
    if (typeof window === "undefined" || !window.visualViewport) return;

    lastHeight = window.visualViewport.height;
    const visualViewport = window.visualViewport;

    const triggerReflow = () => {
      if (!ref) return;
      ref.style.willChange = "transform";
      ref.style.transform = "translateY(0.1px)";
      requestAnimationFrame(() => {
        ref.style.transform = "";
        ref.style.willChange = "";
      });
    };

    const reflowIfHeightChanged = () => {
      const currentHeight = window.visualViewport?.height;
      if (currentHeight !== lastHeight) {
        lastHeight = currentHeight ?? 0;
        clearTimeout(timer);
        timer = window.setTimeout(triggerReflow, 300);
      }
    };

    visualViewport.addEventListener("resize", reflowIfHeightChanged);
    visualViewport.addEventListener("scroll", reflowIfHeightChanged);

    onCleanup(() => {
      visualViewport?.removeEventListener("resize", reflowIfHeightChanged);
      visualViewport?.removeEventListener("scroll", reflowIfHeightChanged);
    });
  });
}
